import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

interface IMobileMenuWrapper {
  isOpen: boolean;
}

const getMenuWrapperStyles = ({ isOpen }: IMobileMenuWrapper) => {
  if (isOpen) {
    return css`
      clip-path: circle(150% at 100% 0);
      transform: none;
      transition: clip-path 0.8s cubic-bezier(0.86, 0, 0.07, 1);
    `;
  }
  return css`
    clip-path: circle(0% at 100% 0);
    transform: scale(0);
    transition: clip-path 0.8s cubic-bezier(0.86, 0, 0.07, 1), transform 0s 0.8s;
  `;
};

export const MobileMenuWrapper = styled.nav<IMobileMenuWrapper>`
  ${getMenuWrapperStyles};
  background: ${theme.colors.primary.black};
  height: 100vh;
  min-height: 100%;
  box-sizing: border-box;
  overflow: auto;
  position: fixed;
  transform-origin: 100% 0;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 10;

  padding: 160px 0px 0px 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ItemSubMenuContainer = styled.div`
  cursor: pointer;
  width: 80%;

  > a {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    margin-bottom: 8px;
    border-radius: 8px;
    text-decoration: none;
    font-size: 12.6px;
    line-height: 48px;
    letter-spacing: 0.04em;
    font-weight: ${theme.weights.semibold};
    color: ${theme.colors.primary.white};

    > label {
      cursor: pointer;
    }

    &:hover,
    &:focus {
      background: ${theme.colors.secondary.gray200}60;
      color: ${theme.colors.primary.white};
    }

    > svg > path {
      fill: ${theme.colors.primary.white};
    }
  }
`;

export const MobileMenuItemHeader = styled.div`
  color: ${theme.colors.secondary.gray200};
  cursor: pointer;
  line-height: 20px;
  text-transform: uppercase;
  transition: 350ms;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  font-size: 16px;
  line-height: 47px;

  > a > svg {
    margin: 0;
    margin-right: 30px;
  }

  > a {
    display: flex;
    flex-grow: 1;
    align-items: center;
    text-decoration: none;
    color: ${theme.colors.secondary.gray200};
  }

  svg .fill {
    fill: ${theme.colors.secondary.gray300};
  }
  & svg .stroke {
    stroke: ${theme.colors.secondary.gray300};
    stroke-width: 2;
  }
`;

export const MobileMenuItens = styled.div`
  display: flex;
  flex-direction: column;

  ${MobileMenuItemHeader}:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${theme.colors.secondary.gray100};
  width: 99vw;
  margin-left: -39px;
`;

export const MobileMenuFooter = styled.div`
  display: flex;
  color: ${theme.colors.secondary.gray300};
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    font-size: 16px;
    line-height: 47px;
    letter-spacing: 2%;

    svg {
      margin: 0;
      margin-right: 30px;
    }
  }

  svg .fill {
    fill: ${theme.colors.secondary.gray300};
  }
  & svg .stroke {
    stroke: ${theme.colors.secondary.gray300};
    stroke-width: 2;
  }
`;
